/* eslint react/forbid-prop-types: 0 */
import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import "react-select/dist/react-select.css";
import { Row, Col } from "react-bootstrap";
import LocationComponent from "./LocationComponent";

const CustomLocation = props => {
  const { location, errors } = props;
  const classNames = errors.location
    ? "invalid job-form-select"
    : "job-form-select";
  const locationTypes = [
    { value: "CUSTOMER", label: "Customer" },
    { value: "JOB", label: "Address" }
  ];

  return (
    <div className="custom-location">
      <Row>
        <Col sm={3} className="cust-label">
          <label className="location-type-label" htmlFor="locationType">
            Location Type
          </label>
        </Col>
        <Col sm={9}>
          <Select
            className={classNames}
            options={locationTypes}
            value={location.type.code}
            onChange={props.handleLocationTypeChange}
            clearable={false}
          />
        </Col>
      </Row>

      <LocationComponent
        location={location}
        handleLocationChange={props.handleChange}
      />
    </div>
  );
};
CustomLocation.propTypes = {
  location: PropTypes.object.isRequired,
  errors: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleLocationTypeChange: PropTypes.func.isRequired
};

export default CustomLocation;



// WEBPACK FOOTER //
// ./src/forms/fields/CustomLocation.js